import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Features } from "@/components/Features";
import { About } from "@/components/About";
import { Stays } from "@/components/Stays";
import { NatureBreaker } from "@/components/NatureBreaker";
import { LeadForm } from "@/components/LeadForm";
import { Testimonials } from "@/components/Testimonials";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";
import { StickyCallBar } from "@/components/StickyCallBar";
import { EnquiryModal } from "@/components/EnquiryModal";

function Landing() {
  const location = useLocation();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalHeading, setModalHeading] = useState("Plan your stay");

  // Open the modal directly when visiting /enquire (great for Google Ads links)
  useEffect(() => {
    if (location.pathname === "/enquire") {
      setModalHeading("Plan your stay");
      setModalOpen(true);
    }
  }, [location.pathname]);

  const openEnquiry = (heading) => {
    setModalHeading(typeof heading === "string" ? heading : "Plan your stay");
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    if (location.pathname === "/enquire") navigate("/", { replace: true });
  };

  return (
    <div className="App bg-[#F6F5F0] min-h-screen overflow-x-hidden">
      <Toaster position="top-center" richColors />
      <Navbar onEnquire={openEnquiry} />
      <main className="pb-16 md:pb-0">
        <Hero onEnquire={() => openEnquiry("Check availability")} />
        <Features />
        <About />
        <Stays onEnquire={() => openEnquiry("View our packages")} />
        <NatureBreaker onEnquire={() => openEnquiry("Plan my stay")} />
        <LeadForm />
        <Testimonials />
        <Faq />
        <Footer onEnquire={() => openEnquiry("Book your stay")} />
      </main>
      <StickyCallBar onEnquire={() => openEnquiry()} />

      <EnquiryModal
        open={modalOpen}
        heading={modalHeading}
        onClose={closeModal}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Landing />
    </BrowserRouter>
  );
}

export default App;
